
@if (showModal) {
  <div class="container-download back-download-modal">
    <!-- Desktop Only -->
    <button (click)="setDateToday()"
      class="buttom-left btn square-btn btn-download-secondary desk-only">
      {{ getTranslate("notNow") }}
    </button>
    <!-- ./ Desktop Only -->
    <!-- Any Screen -->
    <div class="text-center w-100">
      <h6>{{ getTranslate("title") }}</h6>
      <p>{{ getTranslate("description") }}</p>
    </div>
    <!-- ./ Any Screen -->
    <!-- Mobile Only -->
    <div class="d-flex justify-content-center mt-3 mob-only" style="gap: 0.8rem;">
      <button (click)="setDateToday()" class="btn square-btn btn-download-secondary">
        {{ getTranslate("notNow") }}
      </button>
      @if (verifyLink(linkFirebaseStore)) {
        <a target="_blank" [href]="linkFirebaseStore" >
          <button class="btn square-btn btn-download-primary ml-1">
            {{ getTranslate("toDownload") }}
          </button>
        </a>
      }
    </div>
    <!-- ./ Mobile Only -->
    <!-- Desktop Only -->
    <div class="buttom-right desk-only">
      @if (verifyLink(linkAppleStore)) {
        <a target="_blank" [href]="linkAppleStore">
          <img class="store-button-img" [src]="imageDownloadAppleStore" alt="downloadApple" />
        </a>
      }
      @if (verifyLink(linkGoogleStore)) {
        <a target="_blank" [href]="linkGoogleStore">
          <img class="store-button-img" [src]="imageDownloadGoogleStore" alt="downloadGoogle" />
        </a>
      }
    </div>
    <!-- ./ Desktop Only -->
  </div>
}
